<script>
  import asset from "@helpers/asset"
  import { Page, PageTitle } from "@objects/Page"
  import ContentContainer from "@objects/ContentContainer.svelte"
  import Wrap from "@objects/Wrap.svelte"
  import IntersectionObserver from "@objects/IntersectionObserver.svelte"
  import LoadNextPage from "@objects/LoadNextPage.svelte"
  import ProductCard from "@components/ProductCard.svelte"
  import Button from "@components/Button.svelte"
  import AddedToCartDialog from "./AddedToCartDialog.svelte"
  import { addedToCartDialog } from "@store"
  import { onMount } from "svelte"
  import Analytics from "@services/Analytics"

  export let collection
  export let products

  const nextOpts = {
    onComplete: () => {
      setTimeout(() => {
        window.affirm?.ui?.refresh?.()
      }, 0)
    },
  }

  onMount(() => {
    addedToCartDialog.close()
    Analytics.track("User viewed public collection", {
      collectionId: collection.id,
      products: products.data.map(setProduct),
    })
  })

  function setProduct(item) {
    return {
      productId: item.id,
      sku: item.sku,
      productName: item.name,
      price: item.price,
      imageUrl: item.featured_image_url,
    }
  }
</script>

<svelte:head>
  <title>{collection.name}</title>
</svelte:head>

<AddedToCartDialog />

<Page>
  {#if collection.cover_photo_url}
    <Wrap>
      <ContentContainer>
        <img src={asset(collection.cover_photo_url, { width: 1650 })} class="[ w-full mb-4 sm:mb-8 ]" alt="" />
      </ContentContainer>
    </Wrap>
  {/if}

  <header class="[ text-center mb-16 tracking-tight ]">
    <Wrap>
      <ContentContainer>
        <PageTitle>{collection.name}</PageTitle>
      </ContentContainer>
    </Wrap>
  </header>

  <Wrap>
    <ContentContainer>
      <section class="[ grid gap-6 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 ]">
        {#each products.data as product (product.id)}
          <ProductCard {product} {collection} />
        {/each}
      </section>
    </ContentContainer>
  </Wrap>

  <Wrap class="[ mt-36 ]">
    <ContentContainer>
      <LoadNextPage bind:items={products} let:isLoading let:onLastPage let:next>
        <IntersectionObserver on:intersect={next(nextOpts)} bottom="200%">
          <div class="[ mt-12 flex justify-center ]">
            {#if onLastPage}
              <p class="[ text-sm text-center italic ]">All your products have been loaded</p>
            {:else if isLoading}
              <p class="[ text-sm text-center italic ]">Loading more products…</p>
            {:else}
              <Button on:click={next(nextOpts)} type="neutral">Load more products</Button>
            {/if}
          </div>
        </IntersectionObserver>
      </LoadNextPage>
    </ContentContainer>
  </Wrap>
</Page>
